import { Modal } from 'components';
import React, { Dispatch, ReactElement, SetStateAction } from 'react';

import FormCompanySelectModal from './FormCompanySelectModal';

interface Props {
  users: Array<{
    id: number;
    companyName: string;
    firstName: string;
    lastName: string;
  }>;
  selectedId: number | null;
  onSelect: (id: number) => void;
  onClose: () => void;
}

const CompanySelectModal = (props: Props): ReactElement => {
  const { users, selectedId, onSelect, onClose } = props;

  return (
    <Modal open changeModalShow={onClose} widthBox="medium" maxLevel="lvl4">
      <FormCompanySelectModal
        users={users}
        selectedId={selectedId}
        onSelect={onSelect}
      />
    </Modal>
  );
};
export default CompanySelectModal;
